'use strict';
module.exports = function safeJSONParse (str) {
	if (typeof str === 'string') {
		try {
			return JSON.parse(str);
		} catch (e) {
			return false;
		}
	}
	return str;
};
